import Typography from "ds/components/Typography";

const ChangeHistoryCardSeparator = () => (
  <Typography tag="span" variant="p-body3" color="secondary">
    •
  </Typography>
);

export default ChangeHistoryCardSeparator;
